<template>
  <div class="add-reicpient-form-wrapper">
    <b-row>
      <b-col cols="12">
        <b-form-group
          id="fieldset-recipient-number"
          label="Recipient Number:"
          style="font-weight:500"
          label-for="input-recipient-number"
          class="required-form-field"
        >
          <b-form-input
            id="input-recipient-number"
            v-model="number"
            v-mask="'(###) ###-####'"
            trim
            required
          />
          <b-form-invalid-feedback :state="!!errors['number'] ? false : true">
            {{ errors['number'] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="d-flex flex-row-reverse">
      <b-button
        pill
        variant="success"
        @click="addRecipient"
        :disabled="isAddingRecipient"
      >
        <i v-if="isAddingRecipient" class="fa fa-spinner fa-spin"></i>
        <span v-else>Add Recipient</span>
      </b-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { EventBus } from '@/events/eventBus';

export default {
  name: "AddRecipientForm",
  data() {
    return {
      number: "",
      errors: {},
      isAddingRecipient: false,
    };
  },
  computed: {
    ...mapGetters({
      conversation: "conversations/getConversation",
    }),
  },
  methods: {
    validateForm() {
      this.errors = {};
      const realNumber = `${this.number}`.replace(/\D/g,'');
      if (!realNumber) {
        this.errors['number'] = "Recipient phone number is required."
      } else if (realNumber.length !== 10) {
        this.errors['number'] = "Input valid phone number."
      }

      if (Object.keys(this.errors).length > 0) {
        return false;
      }

      return `+1${realNumber}`
    },
    async addRecipient() {
      const validated = this.validateForm();
      if (!validated) {
        return;
      }
      try {
        this.isAddingRecipient = true;
        await this.$ConveyApi.conversationsApi.addRecipientToConversation({
          conversationId: this.$route.params.conversationId,
          payload: [{
            number: validated,
            role: "caller",
            direction: "outbound",
          }]
        });
        this.$toastr("success", "Added recipient successfully.");
        EventBus.$emit("close-modal");
      } catch (err) {
        console.log('[AddRecipientForm:addRecipient] ERROR: ', err);
        this.$toastr("error", "Error occurred adding recipient to the conversation.");
      } finally {
        this.isAddingRecipient = false;
      }
    },
  }
};
</script>

<style lang="scss" scoped>


</style>